@if (isLoading) {
  <aw-spinner [fullScreen]="false"></aw-spinner>
}

<aw-expansion-panel
  appExpansionPanelA11y
  [title]="config.panelTitle"
  [expanded]="false"
  [showExpander]="true"
>
  @if (errorMessage) {
    <div class="error-message">
      <p class="aw-b-1">{{ errorMessage }}</p>
    </div>
  } @else {
    <div class="table-form-container">
      <div>
        <aw-search
          [(ngModel)]="searchValue"
          (ngModelChange)="onSearchTable(searchValue)"
          [ariaLabel]="'Search ' + config.panelTitle"
          [placeholder]="'Search'"
        >
          <mat-icon [svgIcon]="'search'" position="prefix"></mat-icon>
        </aw-search>
      </div>

      <button
        AwButton
        [disable]="disableChangeAssignment"
        (click)="openChangeAssignmentDialog = true"
      >Change Assignment</button>
    </div>

    <aw-table
      [appTableName]="config.panelTitle"
      [columnsDefinition]="columnsDefinition"
      [tableData]="apiAccessTableData()"
      [sortDisabled]="false"
      [enableInfiniteScroll]="true"
      [tableHeight]="tableHeight"
      [displayableRowsCount]="rowBatchSize"
      [stickyHeader]="true"
      (checkboxList)="checkBoxActionHandler($event)"
    >
    </aw-table>

    <aw-dialog
      [visible]="openChangeAssignmentDialog"
      [formFieldsData]="changeAssignmentFormFields()"
      [dialogOptions]="changeAssignmentDialogOptions()"
      (primaryAction)="changeAssignmentFormSubmit($event)"
      (secondaryAction)="dialogFormCloseHandler()"
      ariaLabel="Change table assignment"
    >
    </aw-dialog>
  }
</aw-expansion-panel>
